import classname from 'classnames';
import * as React from 'react';
import { ILinkData } from '../clickable-container/clickable-container.props.autogenerated';
import { ILinkListProps } from './link-list.props.autogenerated';

/**
 *
 * LinkList component
 * @extends {React.Component<ILinkListProps<{}>>}
 */
class LinkList extends React.Component<ILinkListProps<{}>> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {
        const { config } = this.props;
        return (
            <div className={classname('link-list', config.className)}>
                {config.links && this._renderContent(config.links)}
            </div>
        );
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderContent(links: ILinkData[]): JSX.Element {
        const currentPage = this.props.context.request.url.requestUrl.pathname;
        return (
            <div className='link-list__links'>
                {links.map((cta: ILinkData, index: number) => {
                    const isActive = cta.linkUrl?.destinationUrl.split('?')[0] === currentPage;
                    return <a
                        key={`link-${index}`}
                        className={classname('link-list__link', { active: isActive })}
                        title={cta.linkText}
                        href={cta.linkUrl && cta.linkUrl.destinationUrl}
                        aria-label={cta.ariaLabel}
                        target={cta.openInNewTab ? '_blank' : undefined} rel="noreferrer"
                    >
                        {cta.linkText}
                    </a>;
                })}
            </div>
        );
    }
}

export default LinkList;
